var _path, _path2, _path3, _path4;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgDiscount = _ref => {
  let {
      svgRef,
      title
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    stroke: "#4da74d",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.09194 6.2002C4.09194 4.68139 5.32255 3.45079 6.84135 3.44957H8.09263C8.8186 3.44957 9.51416 3.16137 10.0297 2.65065L10.9041 1.77511C11.9754 0.697722 13.7167 0.692858 14.7941 1.76417L14.7953 1.76539L14.8063 1.77511L15.6818 2.65065C16.1974 3.16259 16.893 3.44957 17.6189 3.44957H18.869C20.3878 3.44957 21.6196 4.68018 21.6196 6.2002V7.44905C21.6196 8.17501 21.9066 8.87179 22.4185 9.38738L23.2941 10.2629C24.3715 11.3342 24.3775 13.0756 23.3062 14.153L23.305 14.1542L23.2941 14.1651L22.4185 15.0406C21.9066 15.555 21.6196 16.2506 21.6196 16.9765V18.2278C21.6196 19.7466 20.389 20.9772 18.8702 20.9772H18.869H17.6165C16.8905 20.9772 16.1937 21.2654 15.6794 21.7774L14.8038 22.6517C13.7337 23.7291 11.9936 23.7352 10.9162 22.6663C10.915 22.6651 10.9138 22.6639 10.9126 22.6626L10.9016 22.6517L10.0273 21.7774C9.51294 21.2654 8.81616 20.9785 8.0902 20.9772H6.84135C5.32255 20.9772 4.09194 19.7466 4.09194 18.2278V16.9741C4.09194 16.2482 3.80374 15.5526 3.2918 15.0382L2.41748 14.1627C1.34009 13.0926 1.33401 11.3525 2.4041 10.2751C2.4041 10.2739 2.40532 10.2726 2.40654 10.2714L2.41748 10.2605L3.2918 9.38495C3.80374 8.86936 4.09194 8.1738 4.09194 7.44662V6.2002",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.73145 15.3394L15.9818 9.08911",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M15.8896 15.2521H15.9006",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.80859 9.17246H9.81953",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgDiscount, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/discount.0f831091.svg";
export { ForwardRef as ReactComponent };